export const COMPU_MINUTES_EDITOR_ROUTES = [
  {
    path: 'compu-minutes-editor',
    component: () =>
      import(
        /* webpackChunkName: "view-operations-compu-minutes-editor-wrapper" */ '@/views/pei/compu-minutes-editor/Wrapper.vue'
      ),
    children: [
      {
        path: '',
        name: 'compu-minutes-editor',
        component: () =>
          import(
            /* webpackChunkName: "view-operations-compu-minutes-editor-main" */ '@/views/pei/compu-minutes-editor/Main.vue'
          ),
      },
      {
        path: 'create',
        name: 'compu-minutes-editor-create',
        component: () =>
          import(
            /* webpackChunkName: "view-operations-compu-minutes-editor-create" */ '@/views/pei/compu-minutes-editor/subviews/CreateMinute.vue'
          ),
        props: true,
      },
      {
        path: ':id',
        name: 'compu-minutes-editor-detail',
        component: () =>
          import(
            /* webpackChunkName: "view-operations-compu-minutes-editor-create" */ '@/views/pei/compu-minutes-editor/subviews/CreateMinute.vue'
          ),
        props: true,
      },
    ],
  },
];
